import './index.css'

import React from 'react'
import { Outlet } from 'react-router-dom'
import { useSelector } from 'hooks/use-redux'
import { WATERMARKING } from '@disco/constants/FeatureTypes'
import { useFeatureEnabled } from '@disco/state-management/selectors/business'
import { getWatermarkingQuota } from '@disco/utils/getWatermarkingQuota'
import DocumentHeadTags from 'components/document-head-tags'
import WatermarkBanner from 'components/explorer/watermark-banner'
import { TabNav } from 'components/ui'
import PageContainer from 'components/ui/page-container'
import PageHeader from 'components/ui/page-header'
import QuotaAlert from './quota-alert'
import WatermarkingSplash from './splash'
const TAB_ITEMS = [
  {
    label: 'Playlists',
    link: '/watermarking/playlists',
  },
  {
    label: 'Leak tracing',
    link: '/watermarking/leak-tracing',
  },
]

const Watermarking = (): React.ReactElement<'div'> => {
  const isFeatureEnabled = useFeatureEnabled(WATERMARKING)
  const { quotaUsed } = useSelector(state => getWatermarkingQuota(state))
  return (
    <div className="Page">
      <DocumentHeadTags title="Watermarking | DISCO" />
      {!isFeatureEnabled && <WatermarkingSplash />}
      {isFeatureEnabled && quotaUsed === 0 && (
        <>
          <WatermarkBanner />
          <Outlet />
        </>
      )}
      {isFeatureEnabled && quotaUsed > 0 && (
        <div className="Page_Content">
          <QuotaAlert />
          <PageHeader title="Watermarking" />
          <TabNav className="Tabs--modal" items={TAB_ITEMS} />
          <PageContainer>
            <Outlet />
          </PageContainer>
        </div>
      )}
    </div>
  )
}

export default Watermarking
